import { render, staticRenderFns } from "./AccessProfilesDetailsPage.vue?vue&type=template&id=1f5282d6&scoped=true&"
import script from "./AccessProfilesDetailsPage.vue?vue&type=script&lang=js&"
export * from "./AccessProfilesDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./AccessProfilesDetailsPage.vue?vue&type=style&index=0&id=1f5282d6&lang=scss&scoped=true&"
import style1 from "./AccessProfilesDetailsPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5282d6",
  null
  
)

export default component.exports